
import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class MotionErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Always set hasError for any error that might be motion-related
    console.warn('MotionErrorBoundary caught error:', error.message);
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.warn('Motion system error, using fallback rendering:', error.message);
  }

  render() {
    if (this.state.hasError) {
      // Always use fallback or children without motion
      return this.props.fallback || this.props.children;
    }

    return this.props.children;
  }
}

export default MotionErrorBoundary;
